<div class="presentation">
<div class="background">
   <video autoplay [muted]="'muted'" loop id="myVideo" height="60%">
      <source src="../../../assets/background/background.mp4" type="video/mp4">
   </video>
</div>

<div class="intro" data-aos="fade-down" data-aos-duration="1500">
   <img src="../../../assets/logos/logo.png" id="logo" >
<h2 >
   National Robotics Congress in Tunisia
</h2>
<div class="row intels" >
   <div class="info col"><img src="../../../assets/icons/calendar.png"><p>1-3 July , 2022</p></div>
   <div class="info col"><img src="../../../assets/icons/location.png"><p> Gammarth, Tunis</p></div>
</div>
  
    <p class="counter count overlay" >{{demo}}<br>Till take off</p>
</div>
<div  class="block"  style="background-image: linear-gradient(to bottom, rgba(0, 0, 0, 0.041), rgb(26, 4, 20)),
url(../../../assets/club-pictures/ras.png) ;    background-size: contain;" >
   <div class="content" >
      <p class="counter" data-aos-duration="1000" data-aos="fade-right" > About RAS INSAT</p>
<p class="def" data-aos-duration="1500" data-aos="fade-right" ><span>IEEE RAS INSAT SBC</span> is known as one of the best performing and most active chapters of IEEE Tunisia
   Section . This is thanks to its hard-working members, who constantly prove their
   skills and their dedication to their Student Branch. Indeed, the number of awards
   won attests to this: IEEE RAS chapter won the 2019 Student Branch of the Year
   award, awarded by Region 8, as well as the exemplary branch in Tunisia at TSYP
   2018 and 2017. In addition, IEEE RAS INSAT won the 1st place of the RAS
   challenge in TSYP 2019, all this among many other awards that demonstrate a
   homogeneous and competent branch. 
   <button type="button" class="btn btn-outline"><a href="https://ras-insat.ieee.tn">Explore more</a></button>
   </p>
   </div>
</div>
<div  class="block" style="background-image: linear-gradient(to bottom, rgba(0, 0, 0, 0.041), rgb(26, 4, 20)),
url(../../../assets/club-pictures/nrw.png) ;    background-size: contain;">
   <div class="content">
<p class="counter" data-aos="fade-left" data-aos-duration="1000" > What is NRW?</p>
<p class="def" data-aos="fade-left" data-aos-duration="1500" ><span>National Robotics weekend</span>
   is the annual conference organized by IEEE RAS INSAT, targeting the field of robotics, and which brings
   together future engineers from Tunisia in order to provide them with an exceptional opportunity to
   build new relationships, strengthen their spirit of innovation and challenge and promote their skills in
   various technological fields . We won the "The runner up position in IEEE Region8 (Europe, Middle East
   and Africa) Education Activities's Acceleration Program Contest" in an annual competition organized by
   the IEEE international.</p>
   </div>
   </div>

   <div class="block">
      <p class="counter" data-aos="fade-right" data-aos-duration="1000">Our last edition : NRW 3.1</p>
      <div class="row" data-aos="fade-right" data-aos-duration="1500">
         <div class="element col-sm"><img src="../../../assets/icons/conference.png"><p>4 CONFERENCES </p></div>      
         <div class="element col-sm"> <img src="../../../assets/icons/enterprise.png"><p> 8 <br>COMPANIES</p></div>
         <div class="element col-sm"> <img src="../../../assets/icons/support.png"><p>269 PARTICIPANTS </p></div>
         <div class="element col-sm"> <img src="../../../assets/icons/workshop.png"><p>8 <br> WORKSHOPS </p></div>
      </div>
   </div>
</div>